<template>
  <q-page class="container" padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold self-end">Autenticação</p>
    </div>
    <q-card>
      <q-card-section>
        <q-form ref="myForm" @submit.prevent="onSubmit">
          <div class="row col-12 q-col-gutter-sm">
            <div class="col-md-2 col-sm-12 col-xs-12">
              PROVEDOR ID:
              <q-input
                dense
                outlined
                v-model="autenticacao.autenticacaoProvedorId"
                label="Provedor ID"
                :rules="[
                  (val) => (val && val.length > 0) || 'Campo Obrigatório',
                ]"
              >
                <template v-slot:prepend>
                  <q-icon name="storage" />
                </template>
              </q-input>
            </div>

            <div class="col-md-2 col-sm-12 col-xs-12">
              BD HOST:
              <q-input
                dense
                outlined
                v-model="autenticacao.host"
                label="Host"
                :rules="[
                  (val) => (val && val.length > 0) || 'Campo Obrigatório',
                ]"
              >
                <template v-slot:prepend>
                  <q-icon name="storage" />
                </template>
              </q-input>
            </div>

            <div class="col-md-2 col-sm-12 col-xs-12">
              USER:
              <q-input
                dense
                outlined
                v-model="autenticacao.user"
                label="User"
                :rules="[
                  (val) => (val && val.length > 0) || 'Campo Obrigatório',
                ]"
              >
                <template v-slot:prepend>
                  <q-icon name="person" />
                </template>
              </q-input>
            </div>

            <div class="col-md-2 col-sm-12 col-xs-12">
              PASSWORD:
              <q-input
                dense
                outlined
                v-model="autenticacao.pass"
                label="Password"
                :type="text"
                :rules="[
                  (val) => (val && val.length > 0) || 'Campo Obrigatório',
                ]"
              ></q-input>
            </div>

            <div class="col-md-1 col-sm-12 col-xs-12">
              <p></p>
              <q-btn
                class="q-mt-sm full-width"
                color="positive"
                label="Criar"
                type="submit"
                no-caps
                icon="add"
                v-on:click="criar()"
              />
            </div>
          </div>
        </q-form>
      </q-card-section>
    </q-card>

    <q-card class="q-mt-md">
      <div class="q-pa-md">
        <q-table
          dense
          title="Autenticação"
          :rows="listaAutenticacao"
          :columns="columns"
          @request="atualizarTabela"
          :loading="loading"
          class="tabela-tamanho-fixo"
          :filter="filter"
          row-key="autenticacaoProvedorId"
        >
          <template v-slot:body="props">
            <q-tr :props="props">
              <q-td
                class="text-left"
                key="autenticacaoProvedorId"
                :props="props"
                >{{ props.row.autenticacaoProvedorId }}</q-td
              >
              <q-td class="text-left" key="host" :props="props">{{
                props.row.host
              }}</q-td>
              <q-td class="text-left" key="user" :props="props">{{
                props.row.user
              }}</q-td>
            </q-tr>
          </template>
        </q-table>
      </div>
    </q-card>
  </q-page>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

export default {
  name: "AutenticacaoProvedor",
  setup() {
    const store = useStore();
    const $q = useQuasar();
    const myForm = ref(null);
    const autenticacao = ref({
      autenticacaoProvedorId: "",
      host: "",
      user: "",
      pass: "",
    });

    const loading = ref(true);
    const listaAutenticacao = ref([]);

    const columns = [
      {
        name: "autenticacaoProvedorId",
        label: "AUTENTICAÇÃO",
        field: "autenticacaoProvedorId",
        align: "left",
      },
      { name: "host", label: "HOST", field: "host", align: "left" },
      { name: "user", label: "USER", field: "user", align: "left" },
    ];

    let listarAutenticacao = async () => {
      try {
        let resposta = await store.dispatch("office/listarAutenticacao");
        listaAutenticacao.value = resposta.listaAutenticacao;
        loading.value = false;
      } catch (error) {
        console.error(error);
      }
    };

    onMounted(() => {
      listarAutenticacao();
    });

    let criar = async () => {
      let sucess = await myForm.value.validate();
      if (!sucess) {
        return;
      }

      try {
        await store.dispatch("office/criarAutenticacao", {
          autenticacaoProvedorId: autenticacao.value.autenticacaoProvedorId,
          host: autenticacao.value.host,
          user: autenticacao.value.user,
          pass: autenticacao.value.pass,
        });

        $q.notify({
          message: "Dados Cadastrado!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        reset();
        onReset();
      } catch (e) {
        if (e.request.status < 500) {
          for (let index in e.response.data.erros) {
            $q.notify({
              message: e.response.data.erros[index],
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        }

        if (e.request.status >= 500) {
          $q.notify({
            message: "Erro no servidor, tente novamente",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const onReset = async () => {
      await reset();
      myForm.value.resetValidation();
    };

    const reset = async () => {
      autenticacao.value = {};
    };

    return {
      autenticacao,
      criar,
      myForm,
      listaAutenticacao,
      columns,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
